export const debugPresets = {
    'Smoke': {
        shape: 'spiral', shapeText: 'SMOKE', shapeScale: 2.6,
        morphEnabled: false, morphTarget: 'sphere', morphSpeed: 0.5, morphStrength: 5,
        particleSize: 0, particleShape: 3, shapeSoftness: 0.85,
        particleColor: '#3f4864', colorShift: '#e1e0ff', backgroundColor: '#000000',
        opacityVariance: 0.3, colorVariance: 0.65, sizeVariance: 1.09,
        flashIntensity: 1.5, dimIntensity: 4.78, saturation: 1,
        flowInfluence: 0.15, flowStrength: 0.4, flowFrequency: 0.3,
        mouseRadius: 6, mouseAspect: 1.8, suckStrength: 9.8, alwaysSuck: true, windStrength: 5, mouseTrail: 0.41,
        particleCount: 685000, respawnRate: 0.07,
        damping: 2.5, turbulenceStrength: 0.6, turbulenceFrequency: 0.8,
        enableZoom: true, enablePan: true, enableRotate: true,
        autoRotate: false, autoRotateSpeed: 0,
        bloomEnabled: false, bloomStrength: 0.54, bloomRadius: 1.63, bloomThreshold: 0.88,
        trailEnabled: true, trailAmount: 15.2, trailResolutionScale: 0.5, trailBlurAmount: 0.4, trailBrightPersist: 0, trailBlendMode: 0,
        dofEnabled: true, dofFocus: 18, dofAperture: 0.08, dofMaxBlur: 1,
        toneMapping: 3, exposure: 1,
        revealEnabled: false, revealRadius: 9.4, revealSoftness: 0.15,
        imageFile: 'caravaggio.jpg', plyFile: 'vangogh.ply',
    },
    'Smoke 2': {
        shape: 'sphere', shapeText: 'SMOKE', shapeScale: 1.1,
        morphEnabled: false, morphTarget: 'sphere', morphSpeed: 0.5, morphStrength: 5,
        particleSize: 0, particleShape: 0, shapeSoftness: 0.85,
        particleColor: '#3f4864', colorShift: '#e1e0ff', backgroundColor: '#000000',
        opacityVariance: 0.92, colorVariance: 0.6, sizeVariance: 1.09,
        flashIntensity: 0, dimIntensity: 6.52, saturation: 1,
        flowInfluence: 0.15, flowStrength: 0.4, flowFrequency: 0.3,
        mouseRadius: 4.9, mouseAspect: 1.8, suckStrength: 6.5, alwaysSuck: true, windStrength: 5, mouseTrail: 0,
        particleCount: 240000, respawnRate: 0.4,
        damping: 1.6, turbulenceStrength: 2.9, turbulenceFrequency: 0.7,
        enableZoom: true, enablePan: true, enableRotate: true,
        autoRotate: false, autoRotateSpeed: 0,
        bloomEnabled: false, bloomStrength: 0.54, bloomRadius: 1.63, bloomThreshold: 0.88,
        trailEnabled: true, trailAmount: 60.8, trailResolutionScale: 0.5, trailBlurAmount: 0.4, trailBrightPersist: 0, trailBlendMode: 0,
        dofEnabled: true, dofFocus: 18, dofAperture: 0.08, dofMaxBlur: 1,
        toneMapping: 3, exposure: 1,
        revealEnabled: false, revealRadius: 9.4, revealSoftness: 0.15,
        imageFile: 'caravaggio.jpg', plyFile: 'vangogh.ply',
    },
}
